import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SharedModule } from '@shared/modules/shared.module';
import { LottieComponent } from 'ngx-lottie';

@Component({
	selector: 'app-payment-required',
	imports: [SharedModule, ButtonComponent, LottieComponent],
	templateUrl: './payment-required.component.html',
	styleUrl: './payment-required.component.scss',
})
export class PaymentRequiredComponent {
	private platformId = inject(PLATFORM_ID);
	isBrowser = isPlatformBrowser(this.platformId);

	options = {
		path: 'assets/layout/lottie/payment.json',
		loop: true,
		autoplay: true,
	};

	constructor(private router: Router) {}

	goToDashboard(): void {
		this.router.navigate(['/dashboard']);
	}

	contactSupport(): void {
		// TODO: Implement logic to contact support
	}
}
